/**
 * Corpo útil do erro da API (fetchData rejeita com response.data; axios usa error.response.data).
 * Não use error.data sozinho: em respostas { message, data: "claimed_by=..." }, data é string auxiliar.
 */
export function normalizeApiErrorBody(error) {
  const fromAxios = error?.response?.data;
  if (fromAxios && typeof fromAxios === "object" && !Array.isArray(fromAxios)) {
    return fromAxios;
  }
  if (
    error &&
    typeof error === "object" &&
    !Array.isArray(error) &&
    typeof error.message === "string"
  ) {
    return error;
  }
  return {};
}

/** Parseia strings tipo "claimed_by=xvision" ou "a=1&b=2". */
export function parseKeyValueDataString(s) {
  if (typeof s !== "string" || !s.trim()) return {};
  const out = {};
  for (const part of s.split("&")) {
    const idx = part.indexOf("=");
    if (idx === -1) continue;
    const key = part.slice(0, idx).trim();
    const val = part.slice(idx + 1).trim();
    if (key) out[key] = val;
  }
  return out;
}
